import React, { useState } from 'react';
import { Modal, Section, Typography } from 'common/components';
import { ChevronRightIcon } from '@fronton/icons-react';
import { createElementKey, removeSpecialCharacters } from 'utils';
import { analyticsUtils } from 'utils/analytics-utils';
import { CABINET_ELEMENT_BLOCK } from '../../cabinet-constants';
import {
  cabinetBenefitsGrid,
  cabinetBenefitsItem,
  cabinetBenefitsItemContent,
  cabinetBenefitsItemImage,
  cabinetBenefitsItemIcon,
  cabinetBenefitsItemIconWrapper,
  cabinetBenefitsModal,
  cabinetBenefitsItemText,
} from './cabinet-benefits-styles';
import { CABINET_BENEFITS_LIST, HeaderCardStructure } from './cabinet-benefits-constants';

type CabinetBenefitsProps = {
  signUpHref: string;
}

export const CabinetBenefits: React.FC<CabinetBenefitsProps> = ({ signUpHref }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [activeItem, setActiveItem] = useState<HeaderCardStructure | null>(null);

  const handleItemClick = (item: HeaderCardStructure) => () => {
    setActiveItem(item);
    setIsModalOpen(true);

    analyticsUtils.clickButtonEvent(
      CABINET_ELEMENT_BLOCK,
      removeSpecialCharacters(item.text),
      'Шкафы, двери и гардеробные на заказ'
    );
  };

  return (
    <Section>
      <ul className={cabinetBenefitsGrid}>
        {CABINET_BENEFITS_LIST.map((item, index) => (
          <li key={createElementKey('header-item', index)}>
            <button className={cabinetBenefitsItem} onClick={handleItemClick(item)}>
              <img
                className={cabinetBenefitsItemImage}
                src={item.icon.src}
                alt={item.icon.alt}
                width="36"
                height="36"
              />
              <div className={cabinetBenefitsItemContent}>
                <Typography
                  className={cabinetBenefitsItemText}
                  variant="m"
                  size="body_long"
                >
                  {item.text}
                </Typography>
                <div className={cabinetBenefitsItemIconWrapper}>
                  <ChevronRightIcon
                    className={cabinetBenefitsItemIcon}
                    type="outline"
                    size="l"
                    color="text-minor"
                  />
                </div>
              </div>
            </button>
          </li>
        ))}
      </ul>

      {
        activeItem && (
          <Modal
            className={cabinetBenefitsModal}
            onClose={() => setIsModalOpen(false)}
            show={isModalOpen}
            size="m"
            variant="curtain">
            <activeItem.modal onCloseModal={() => setIsModalOpen(false)} signUpHref={signUpHref} />
          </Modal>
        )
      }
    </Section>
  )
}
